var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('button',{staticStyle:{"display":"none"},on:{"click":_vm.reload}},[_vm._v("reload")]),_c('div',{staticClass:"col-xl-3"},[_c('profile-header'),_c('profile-wallet'),_c('profile-generate-kyc'),_c('profile-mdr-settings')],1),_c('div',{staticClass:"col-xl-9"},[_c('profile-information'),_c('profile-kyc-details')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }